module.exports = __webpack_public_path__ + "static/media/leak-pod.082a564e.svg";